import { MainConfig, Language } from './models';
import { config } from '../../longread.config';
import { isEnglish } from '../utils/helper/helpers';

const lang = isEnglish() ? Language.EN : Language.DE;

// @ts-ignore
const URL = __URL__;

const { de, en, ...otherConfig } = config;

export const mainConfig: MainConfig = {
    url: `${URL}${lang === 'en' ? '/en' : ''}`,
    title: config[lang].title,
    description: config[lang].description,
    headline: config[lang].headline,
    mobileShareText: config[lang].mobileShareText,
    twitterShareText: config[lang].twitterShareText,
    whatsappShareText: config[lang].whatsappShareText,
    mailShareText: config[lang].mailShareText,
    ...otherConfig
};
